








































































import {Component, PropSync} from 'vue-property-decorator'
import BaseFilter from "@/components/Filter/BaseFilter";
import {DatePickerWings, FastDateDetailWings, SelectWings} from "wings-ui-components";
import {Action, Getter} from "vuex-class";
import { BulkDistrFilter, BulkDistrFilterImpl } from '@/store/user_management/distr_moderation/types';
import { beginningOfCurrentDay, currentDateEnd, dateFilter } from '@/utils/date-util';
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({
  components: {SelectWings, DatePickerWings, FastDateDetailWings},
  filters: {dateFilter}
})
export default class ModerationDistributionsFilter extends BaseFilter<BulkDistrFilter>{

  @PropSync('show') is_show!: boolean;

  @Action("getBulkDistrList") actionGetDistributions: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("getTransports") actionGetTransports: any;

  @Getter("transports") transportsList: any;

  get transportsForOriginatorsList() {
    return this.transportsList.filter((value:any) => value.name.toLowerCase() !== 'ussd');
  }

  defaultFilter(): BulkDistrFilter {
    return new BulkDistrFilterImpl(beginningOfCurrentDay(), currentDateEnd());
  }

  partnersList: any = [];

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners(filter);
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async created() {
    this.actionGetTransports();
    this.actionGetDistributions(this.filter);
    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Distribution",
        addititional_info: getTranslatedParams(this.filter)
      };
      await this.actionGetDistributions(this.filter);
      await this.actionLog(this.logObject);
    } catch (err){
      await this.actionLog({...this.logObject, action_status: "failed"});
    }
  }
}
